export default "__VITE_ASSET__CNQc3ZSt__"